module.exports = __webpack_public_path__ + "static/media/background.d4a57207.svg";